import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {AirlinesService} from '../../../services/airlines.service';
import {ToastrService} from 'ngx-toastr';
import {AirlineModel} from '../../../models/AirlineModel';
import {takeUntil} from 'rxjs/operators';
import {ViewportService} from '../../../services/viewport.service';
import {Subject} from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { UserModel } from 'src/app/models/User';

@Component({
    selector: 'favorite-airline-modal',
    templateUrl: './favorite-airline-modal.component.html',
    styleUrl: './favorite-airline-modal.component.css'
})
export class FavoriteAirlineModalComponent implements OnInit, OnDestroy {
    airlines: AirlineModel[] = [];
    @Input() visible = false;
    @Output() onClose = new EventEmitter<void>();
    private destroy$ = new Subject<void>();
    hoveredAirlineId: number | null = null;
    maxCount = 3;
    user: UserModel;


    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private airlineService: AirlinesService,
        private toast: ToastrService,
        public viewport: ViewportService,
        private auth: AuthService,
        private mixpanel: MixpanelService
    ) {
    }

    ngOnInit() {
        this.viewport.dimensions$.pipe(
            takeUntil(this.destroy$)
        ).subscribe();
        this.airlines = [...(this.config.data?.airlines)] || [];
        this.auth.user$.subscribe((u) => {
            this.user = u;
            this.mixpanel.identify(u.id.toString());
        });
    }

    ngOnDestroy(): void {
    }

    hide() {
        this.onClose.emit();
    }

    close() {
        this.ref.close(this.airlines);
    }

    searchAirlines = (term: string) => this.airlineService.searchAirlines(term);


    onAddAirline = (a: AirlineModel) => {
        if (this.airlines.length >= this.maxCount) {
            this.toast.warning(`You can choose up to ${this.maxCount} favorite airlines`);
            return;
        }
        if (this.airlines.some(x => x.id === a.id)) {
            this.toast.info(`${a.name} is already in your list`);
            return;
        }

        this.airlines = [a, ...this.airlines]; //added outside of next:() block to feel more "automatic"
        this.airlineService.setAirline(a.id).subscribe({
            next: () => {
                this.mixpanel.track('Airline added', {
                    airline: a.name
                });
            },
            error: () => {
                this.airlines = this.airlines.filter(x => x.id !== a.id);
                this.toast.error('Could not save that airline. Please try again.');
            }
        });
    };

    removeAirline(airline: AirlineModel) {
        this.airlines = this.airlines.filter(a => a.id !== airline.id); //added outside of next:() block to feel more "automatic"
        this.airlineService.removeAirline(airline.id).subscribe({
            next: () => {
                this.mixpanel.track('Airline removed', {
                    airline: airline.name
                });
            },
            error: () => {
                this.airlines = [airline, ...this.airlines]
                this.toast.error('Could not remove that airline. Please try again.')
            }
        });
    }
}
